import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import TextInputTwoRowReverse from "components/GenericComponent/TextInputTwoRowReverse";
import UploadCustomerImage from "components/GenericComponent/UploadCustomerImage";
import React from "react";
import Autocomplete from "react-autocomplete";
import DatePicker from "react-datepicker";
import { convertDate } from "utils/formatDate";
import { Controller } from "react-hook-form";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import CheckNoXauApi from "service/checkNoXauApi";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import moment from "moment";
import DanhDachIcloudApi from "../../../service/QuanTriHeThong/DanhDachIcloudApi";
import CauHinhThongKeKhachHangApi from "service/CauHinhThongKeKhachHangApi";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import cauHinh from "utils/cauHinh";
import configsRole from "utils/configsRole";
import { kiemTraQuyen, quyenBanDau } from "utils/quyenNguoiDung";
import ModalXemKhachHang from "./ModalXemKhachHang";
import CustomerApi from "service/customerApi";
// Các ô được coi là "định danh" khách hàng: sửa lệch so với KH đang gắn thì phải xác nhận
const NHAN_DINH_DANH = {
  CustomerName: "Họ tên",
  Phone: "Số điện thoại",
  CMT: "Số CCCD",
  Address: "Địa chỉ",
};
class CustomerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CustomerID: 0,
      CustomerName: "",
      FirstName: " ",
      LastName: "",
      Birthday: "",
      Phone: "",
      Address: "",
      CMT: "",
      DateCMT: "",
      AddressCMT: "",
      Code: "",
      HKTT: "",
      Status: 0,
      Type: "",
      Profession: "",
      WorkAddress: "",
      Income: "",
      PersonContact: "",
      PhoneContact: "",
      Note: "",
      NameWife: "",
      PhoneWife: "",
      ProfessionWife: "",
      NameFather: "",
      PhoneFather: "",
      ProfessionFather: "",
      NameMother: "",
      PhoneMother: "",
      ProfessionMother: "",
      NoteFamily: "",
      Img: "",
      IsCus: true,
      IsSup: false,
      showInfo: false,
      parInfo: false,
      difInfo: false,
      type: "",
      NguonKhId: "",
      Email: "",
      DebtLevel: 0,
      LoaiDoiTac: 1,
      NguoiTheoDoi: "",
      loadedCustomer: 0,
      showClear: false,
      showButtonClear: false,
      IsCopy: null,
      CodeCuaHang: "",
      IsNoXau: false,
      listTinhTrangNo: [],
      listTaiKhoanIcloud: [],
      TenTaiKhoanIcloud: "",
      SoDienThoaiIcloud: "",
      TaiKhoanIcloudId: 0,
      isLoadIcloud: 0,
      SoHDLienKet: -1,
      sSearchNguonKhachHang: "",
      comboNguonKhachHangShow: [],
      isLoadTenNguonKH: 0,
      // Cấu hình thống kê khách hàng
      NgheNghiepId: "",
      KhuVucId: "",
      HinhThucVayId: "",
      comboNgheNghiep: [],
      comboKhuVuc: [],
      comboHinhThucVay: [],
      isLoadThongKeKhachHang: 0,
      isMoney88: false,
      // Giá trị đang gõ ở ô Họ tên (RHF giữ value thật), chỉ dùng để so sánh định danh
      CustomerNameNhap: null,
      // Ảnh chụp định danh KH tại thời điểm gắn CustomerID (chọn từ dropdown)
      snapshotKH: null,
      // Người dùng đã bấm "Đúng khách này - Cập nhật thông tin"
      xacNhanGhiDe: false,
      // Khách khác trong hệ thống có cùng số CCCD vừa nhập
      khachTrungCCCD: null,
      // CCCD của khách đang gắn (chọn từ dropdown hoặc hợp đồng đang sửa): nhập lại đúng số này không phải trùng
      cmtKhachDangGan: null,
      // Số CCCD người dùng đã bấm "Không, đây là người khác" thì không hỏi lại
      cmtBoQuaTrung: null,
      showXemKhachHang: false,
      quyenThongTinKhachVay: quyenBanDau(configsRole.sRole.thongtinkhachvay),
      quyenThongTinKhac: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thongtinkhac,
      ),
      quyenThanhPhanGiaDinh: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thanhphangiadinh,
      ),
      quyenThongTinChoVay: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thongtinchovay,
      ),
      quyenGhiChu: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu,
      ),
      quyenThongTinKhacGiaDinh: quyenBanDau(
        configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac,
      ),
    };
  }
  componentDidMount() {
    let {
      customerId,
      getDetailCustomer,
      IsEditCustomer,
      isCauHinhTaiKhoanIcloud,
    } = this.props;
    if (customerId) {
      getDetailCustomer({ customerId: customerId });
      if (customerId > 0) {
        this.setState({ showClear: true, showButtonClear: true });
      }
    }
    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      console.log(response, "aaaaaaaaaaaaaaaa11111");
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        this.setState({ listTinhTrangNo: dataComboTinhTrang });
      }
    });
    if (typeof isCauHinhTaiKhoanIcloud !== "undefined") {
    }
    this.getCauHinhMoney88();
    this.getQuyenThongTinKhac();
  }

  //Quyền "Thông tin khách vay" tắt thì ẩn nút mở "Thông tin cá nhân"
  //Các quyền tab con: tắt thì ẩn tab, vẫn giữ pane trong DOM để không mất dữ liệu khi submit
  //Quyền cấp 3 (ghi chú / thông tin khác của gia đình): tắt thì chỉ ẩn đúng ô đó
  getQuyenThongTinKhac = () => {
    Promise.all([
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thanhphangiadinh),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinchovay),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu),
      kiemTraQuyen(
        configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac,
      ),
    ]).then(
      ([
        quyenThongTinKhachVay,
        quyenThongTinKhac,
        quyenThanhPhanGiaDinh,
        quyenThongTinChoVay,
        quyenGhiChu,
        quyenThongTinKhacGiaDinh,
      ]) =>
        this.setState({
          quyenThongTinKhachVay,
          quyenThongTinKhac,
          quyenThanhPhanGiaDinh,
          quyenThongTinChoVay,
          quyenGhiChu,
          quyenThongTinKhacGiaDinh,
        }),
    );
  };
  //Combo nghề nghiệp / khu vực / hình thức vay lấy từ màn Cấu hình thống kê khách hàng
  getComboThongKeKhachHang = () => {
    const mapCombo = (res) =>
      (res.data || []).map((item) => ({
        value: item.Id,
        label: item.Ten,
        isActive: item.IsActive,
      }));
    CauHinhThongKeKhachHangApi.danhSach({ loai: "nghenghiep" })
      .then((res) => this.setState({ comboNgheNghiep: mapCombo(res) }))
      .catch(() => this.setState({ comboNgheNghiep: [] }));
    CauHinhThongKeKhachHangApi.danhSach({ loai: "khuvuc" })
      .then((res) => this.setState({ comboKhuVuc: mapCombo(res) }))
      .catch(() => this.setState({ comboKhuVuc: [] }));
    CauHinhThongKeKhachHangApi.danhSach({ loai: "hinhthucvay" })
      .then((res) => this.setState({ comboHinhThucVay: mapCombo(res) }))
      .catch(() => this.setState({ comboHinhThucVay: [] }));
  };

  //Chỉ công ty bật cấu hình isMoney88 mới hiển thị Nghề nghiệp / Khu vực / Hình thức vay
  getCauHinhMoney88 = () => {
    ConfigSystemApi.GetConfigSystemByKeyConfig({
      key: cauHinh.sKey.IsMoney88,
    })
      .then((res) => {
        const value = res.data;
        const isMoney88 =
          value === true ||
          value === 1 ||
          value === "1" ||
          value === "True" ||
          value === "true";
        this.setState({ isMoney88 });
        if (isMoney88) {
          this.getComboThongKeKhachHang();
        }
      })
      .catch(() => this.setState({ isMoney88: false }));
  };

  //Combo nghề nghiệp / khu vực / hình thức vay lấy từ màn Cấu hình thống kê khách hàng
  getComboThongKeKhachHang = () => {
    const mapCombo = (res) =>
      (res.data || []).map((item) => ({
        value: item.Id,
        label: item.Ten,
        isActive: item.IsActive,
      }));
    CauHinhThongKeKhachHangApi.danhSach({ loai: "nghenghiep" })
      .then((res) => this.setState({ comboNgheNghiep: mapCombo(res) }))
      .catch(() => this.setState({ comboNgheNghiep: [] }));
    CauHinhThongKeKhachHangApi.danhSach({ loai: "khuvuc" })
      .then((res) => this.setState({ comboKhuVuc: mapCombo(res) }))
      .catch(() => this.setState({ comboKhuVuc: [] }));
    CauHinhThongKeKhachHangApi.danhSach({ loai: "hinhthucvay" })
      .then((res) => this.setState({ comboHinhThucVay: mapCombo(res) }))
      .catch(() => this.setState({ comboHinhThucVay: [] }));
  };

  //Thuộc tính đã khóa ở màn Cấu hình thống kê khách hàng thì không cho chọn mới,
  //nhưng vẫn giữ lại giá trị khách hàng cũ đang gắn để không mất dữ liệu khi sửa.
  comboConHieuLuc = (list, idDangChon) =>
    (list || []).filter(
      (item) =>
        item.isActive !== 0 || String(item.value) === String(idDangChon),
    );

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {
      currentForm,
      customer,
      IsCopy,
      dataTaiSanIcloudChon,
      isCauHinhTaiKhoanIcloud,
    } = this.props;
    const { setValue } = currentForm;
    if (prevProps.customer.customerDetail !== customer.customerDetail) {
      setValue(
        "customer.CustomerName",
        customer.customerDetail.FirstName +
          " " +
          customer.customerDetail.LastName,
      );
      this.checkNoXau();
    }

    if (prevState.IsCopy !== IsCopy && IsCopy) {
      this.setState({ showClear: IsCopy, IsCopy, showButtonClear: IsCopy });
    }

    let { isLoadIcloud, isLoadTenNguonKH, sSearchNguonKhachHang, NguonKhId } =
      this.state;
    if (isLoadTenNguonKH == 0) {
      // Ưu tiên tên nguồn khách API trả về; nếu API không có tên (chỉ có id)
      // thì tra ngược từ combo theo NguonKhId để ô vẫn hiển thị khi sửa hợp đồng
      let tenNguonKh = customer.customerDetail.TenNguonKh;
      let { comboNguonKhachHang } = this.props;
      if (
        !tenNguonKh &&
        NguonKhId > 0 &&
        comboNguonKhachHang &&
        comboNguonKhachHang.length > 0
      ) {
        let nguon = comboNguonKhachHang.find(
          (item) => `${item.value}` === `${NguonKhId}`,
        );
        if (nguon) tenNguonKh = nguon.label;
      }
      if (tenNguonKh && tenNguonKh != sSearchNguonKhachHang) {
        this.setState({
          sSearchNguonKhachHang: tenNguonKh,
          isLoadTenNguonKH: 1,
        });
      }
    }

    if (isCauHinhTaiKhoanIcloud == true) {
      if (
        dataTaiSanIcloudChon &&
        typeof dataTaiSanIcloudChon.TenTaiKhoan != "undefined" &&
        isLoadIcloud == 0 &&
        dataTaiSanIcloudChon.IdTaiKhoan > 0
      ) {
        console.log("111111111111111111111111");

        this.setState({
          TenTaiKhoanIcloud:
            dataTaiSanIcloudChon.TenTaiKhoan +
            "-" +
            dataTaiSanIcloudChon.SoDienThoai,
          TaiKhoanIcloudId: dataTaiSanIcloudChon.IdTaiKhoan,
          SoDienThoaiIcloud: dataTaiSanIcloudChon.SoDienThoai,
          isLoadIcloud: 1,
        });
        setValue(
          "customer.TenTaiKhoanIcloud",
          dataTaiSanIcloudChon.SoDienThoai +
            "-" +
            dataTaiSanIcloudChon.TenTaiKhoan,
        );
        setValue("customer.TaiKhoanIcloudId", dataTaiSanIcloudChon.IdTaiKhoan);
      }
    }
  }
  componentWillUnmount() {
    this.clearCustomer()();
  }
  onSearchTaiKhoanIcloud = (data) => {
    this.setState({ TaiKhoanIcloudId: 0 });
    DanhDachIcloudApi.list({
      SoDienThoai: "",
      TenTaiKhoan: data,
      SoHDLienKet: -1,
      iHanChe: -1,
      iLock: 0,
      iPageSize: 20,
      iPageIndex: 1,
    }).then((response) => {
      if (response.status == "200") {
        this.setState({ listTaiKhoanIcloud: response.data.List });
      }
    });
  };
  onSelectIcloud = (TenTaiKhoan, taikhoanICloud) => {
    this.setState({
      TenTaiKhoanIcloud:
        taikhoanICloud.TenTaiKhoan + "-" + taikhoanICloud.SoDienThoai,
      TaiKhoanIcloudId: taikhoanICloud.Id,
      SoHDLienKet: taikhoanICloud.SoHDLienKet,
    });
  };
  onChangeTextIcloud = (event, value) => {
    this.setState({
      TenTaiKhoanIcloud: value,
    });

    this.onSearchTaiKhoanIcloud(event.target.value);
  };
  static getDerivedStateFromProps(props, state) {
    let { customer, customerId } = props;
    let { customerDetail } = customer;
    let { loadedCustomer } = state;
    if (
      customerId &&
      customerDetail &&
      customerDetail.CustomerId &&
      loadedCustomer === 0 &&
      loadedCustomer !== customerDetail.CustomerId &&
      customerId === customerDetail.CustomerId
    ) {
      return {
        ...customerDetail,
        Birthday: convertDate(customerDetail.Birthday),
        DateCMT: convertDate(customerDetail.DateCMT),
        CustomerName: customerDetail.FirstName + " " + customerDetail.LastName,
        loadedCustomer: customerDetail.CustomerId,
        CustomerID: customerId,
        cmtKhachDangGan: customerDetail.CMT || "",
        NgheNghiepId: customerDetail.NgheNghiepId ?? "",
        KhuVucId: customerDetail.KhuVucId ?? "",
        HinhThucVayId: customerDetail.HinhThucVayId ?? "",
      };
    } else return state;
  }
  onChangeCustomerText = (field) => (event) => {
    // Kiểm tra nếu mà Scan QR thì xử lý
    var value = event.target.value;
    var arr = value.split("|");
    if (arr.length == 7) {
      let state = this.state;
      state.Birthday = convertDate(
        moment(arr[3], "DDMMYYYY").format("DD/MM/YYYY"),
      );
      state.DateCMT = convertDate(
        moment(arr[6], "DDMMYYYY").format("DD/MM/YYYY"),
      );
      state.CMT = arr[0];
      state.CustomerName = arr[2];
      state.CustomerNameNhap = arr[2];
      state.HKTT = arr[5];
      state.Address = arr[5];
      this.setState(state);
      let { currentForm, customer } = this.props;
      customer.CustomerName = arr[2];
      const { setValue } = currentForm;
      setValue("customer.CustomerName", arr[2]);
      // Quét QR điền CCCD mà không đi qua ô CCCD nên kiểm tra trùng luôn
      this.kiemTraTrungCCCD(arr[0]);
    } else {
      let { getAutocompleteCustomer, IsEditCustomer } = this.props;
      if (!IsEditCustomer) this.setState({ CustomerID: 0, CustomerId: 0 });
      // Ghi lại tên đang gõ + huỷ xác nhận ghi đè cũ
      this.setState({ CustomerNameNhap: value, xacNhanGhiDe: false });
      getAutocompleteCustomer({ tuKhoa: value });
    }
  };
  onChangeData = (field) => (event) => {
    let state = this.state;
    state[field] = event.target.value;
    // Sửa lại ô định danh => phải xác nhận ghi đè lại từ đầu
    if (["Phone", "CMT", "Address"].indexOf(field) > -1) {
      state.xacNhanGhiDe = false;
    }
    if (field === "CMT") state.khachTrungCCCD = null;
    this.setState(state);
    // if (field == "CMT" || field == "Phone") {
    //   alert(field);
    // }
  };

  /**
   * Dùng cho các select bắt buộc (nghề nghiệp / khu vực / hình thức vay / nguồn
   * khách). Giá trị vẫn nằm ở state để hiển thị, còn field của react-hook-form
   * là ô hidden đi kèm — KHÔNG register thẳng lên select.
   *
   * Lý do: react-hook-form gắn listener "change" trực tiếp lên DOM node được
   * register. Listener đó chạy trước onChange của React, và khi nó xóa lỗi thì
   * form re-render ngay lập tức với value cũ trong state, khiến React kéo select
   * về giá trị cũ. onChange của React sau đó đọc được giá trị đã bị kéo về nên
   * lần chọn đầu tiên không ăn — phải chọn lần 2 mới được.
   *
   * Sau khi state cập nhật (ô hidden đã có giá trị mới) mới validate lại để
   * thông báo "Hãy chọn ..." biến mất ngay khi người dùng chọn.
   */
  onChangeSelectBatBuoc = (field) => (event) => {
    const value = event.target.value;
    this.setState({ [field]: value }, () => {
      const { currentForm } = this.props;
      if (currentForm && currentForm.trigger) {
        currentForm.trigger(`customer.${field}`);
      }
    });
  };

  onBlur = (field) => (event) => {
    let val = event.target.value;
    if (field == "CMT" || field == "Phone") {
      this.checkNoXau();
    }
    if (field == "CMT") this.kiemTraTrungCCCD(val);
  };

  kiemTraTrungCCCD = (cmt) => {
    const giaTri = (cmt || "").trim();
    const { CustomerID, cmtKhachDangGan, cmtBoQuaTrung } = this.state;
    const laKhachDangGan =
      parseInt(CustomerID, 10) > 0 && giaTri === (cmtKhachDangGan || "").trim();
    if (!giaTri || laKhachDangGan || giaTri === cmtBoQuaTrung) {
      this.setState({ khachTrungCCCD: null });
      return;
    }
    CustomerApi.kiemTraTrungCCCD({
      cmt: giaTri,
      customerId: parseInt(CustomerID, 10) || 0,
    }).then((response) => {
      // Người dùng đã sửa số khác trong lúc chờ thì bỏ kết quả cũ
      if ((this.state.CMT || "").trim() !== giaTri) return;
      this.setState({
        khachTrungCCCD:
          response.status === 200 && response.data && response.data.CustomerID
            ? response.data
            : null,
      });
    });
  };

  dungKhachTrungCCCD = () => () => {
    const khach = this.state.khachTrungCCCD;
    if (!khach) return;
    const { currentForm } = this.props;
    // Giống chọn khách ở dropdown Họ tên: ô Họ tên của react-hook-form nhận DinhDanh
    this.onSelectCustomer(khach.DinhDanh, khach);
    if (currentForm && currentForm.setValue)
      currentForm.setValue("customer.CustomerName", khach.DinhDanh);
    this.setState({ khachTrungCCCD: null });
  };

  boQuaKhachTrungCCCD = () => () => {
    this.setState({
      khachTrungCCCD: null,
      cmtBoQuaTrung: (this.state.CMT || "").trim(),
    });
  };

  onSelectCustomer = (tenKhachHang, customer) => {
    let { checkEditCustomer } = this.props;
    checkEditCustomer(customer.CustomerID);
    let fistName = customer.FirstName.trim();
    let lastName = customer.LastName.trim();
    let customerName = fistName + "" + lastName;
    var a = convertDate(customer.Birthday);
    this.setState({
      ...customer,
      Birthday: convertDate(customer.Birthday),
      DateCMT: convertDate(customer.DateCMT),
      CustomerName: customerName,
      CustomerNameNhap: customerName,
      showClear: true,
      showButtonClear: true,
      snapshotKH: {
        CustomerName: customerName,
        Phone: customer.Phone || "",
        CMT: customer.CMT || "",
        Address: customer.Address || "",
      },
      xacNhanGhiDe: false,
      cmtKhachDangGan: customer.CMT || "",
      khachTrungCCCD: null,
      NgheNghiepId: customer.NgheNghiepId ?? "",
      KhuVucId: customer.KhuVucId ?? "",
      HinhThucVayId: customer.HinhThucVayId ?? "",
    });
    this.checkNoXau1(customer.Phone, customer.CMT);
  };
  onChangeImg = () => (Img) => {
    this.setState({ Img });
  };
  onChangeDate = (field) => (evt) => {
    let state = this.state;
    state[field] = evt;
    this.setState(state);
  };
  clearCustomer = () => () => {
    let { currentForm, setEnableEditCustomer, customer } = this.props;
    const { setValue } = currentForm;
    setValue("customer.CustomerName", "");
    customer.customerDetail = {};
    let state = this.setState({
      CustomerID: 0,
      CustomerName: "",
      FirstName: "",
      LastName: "",
      Birthday: "",
      Phone: "",
      Address: "",
      CMT: "",
      DateCMT: "",
      AddressCMT: "",
      Code: "",
      HKTT: "",
      Status: 0,
      Type: "",
      Profession: "",
      WorkAddress: "",
      Income: "",
      PersonContact: "",
      PhoneContact: "",
      Note: "",
      NameWife: "",
      PhoneWife: "",
      ProfessionWife: "",
      NameFather: "",
      PhoneFather: "",
      ProfessionFather: "",
      NameMother: "",
      PhoneMother: "",
      ProfessionMother: "",
      NoteFamily: "",
      Img: "",
      IsCus: true,
      IsSup: false,
      showInfo: false,
      parInfo: false,
      difInfo: false,
      type: "",
      NguonKhId: "",
      Email: "",
      DebtLevel: 0,
      LoaiDoiTac: 1,
      NguoiTheoDoi: "",
      loadedCustomer: 0,
      showClear: false,
      showButtonClear: false,
      IsNoXau: false,
      CustomerNameNhap: null,
      snapshotKH: null,
      xacNhanGhiDe: false,
      khachTrungCCCD: null,
      cmtKhachDangGan: null,
      cmtBoQuaTrung: null,
      NgheNghiepId: "",
      KhuVucId: "",
      HinhThucVayId: "",
    });

    this.setState(state);
    setEnableEditCustomer({ IsEditCustomer: true });
  };

  fomatNameCUstomer = (name) => () => {
    return name.trim();
  };

  checkNoXau = () => {
    let { Phone, CMT } = this.state;
    CheckNoXauApi.checkNoXau(Phone, CMT).then((response) => {
      if (response && response.data && response.data.NoXau != null) {
        let state1 = this.state;
        state1.IsNoXau = response.data.NoXau;
        this.setState(state1);
      }
    });
  };

  checkNoXau1 = (Phone, CMT) => {
    CheckNoXauApi.checkNoXau(Phone, CMT).then((response) => {
      if (response && response.data && response.data.NoXau != null) {
        let state1 = this.state;
        state1.IsNoXau = response.data.NoXau;
        this.setState(state1);
      }
    });
  };
  /**
   * Click/focus vào ô Nguồn khách hàng thì đổ luôn toàn bộ danh sách để chọn,
   * không cần gõ chữ mới thấy gợi ý.
   */
  moDanhSachNguonKhachHang = () => {
    let { comboNguonKhachHang } = this.props;
    let lstNguon = (comboNguonKhachHang || []).filter((item) => item.value > 0);
    this.setState({ comboNguonKhachHangShow: lstNguon });
  };
  onSelectNguonKhachHang1 = (value, nguonkhachhang) => {
    let { NguonKhId, sSearchNguonKhachHang } = this.state;
    NguonKhId = nguonkhachhang.NguonKhId;
    sSearchNguonKhachHang = value;
    this.setState({ NguonKhId, sSearchNguonKhachHang }, () => {
      // Ô hidden customer.NguonKhId đã có giá trị mới -> xóa thông báo bắt buộc
      const { currentForm } = this.props;
      if (currentForm && currentForm.trigger) {
        currentForm.trigger("customer.NguonKhId");
      }
    });
  };
  onChangeNguonKhachHang1 = (event, value) => {
    let { comboNguonKhachHang } = this.props;
    let lstNguon = comboNguonKhachHang.filter(function (item) {
      return item.value > 0 && (item.label.indexOf(value) > -1 || value == "");
    });

    this.setState({
      sSearchNguonKhachHang: value,
      comboNguonKhachHangShow: lstNguon,
    });
    let { NguonKhId } = this.state;
    NguonKhId = 0;
    this.setState({ NguonKhId });
  };

  // ===== Chống ghi đè nhầm thông tin khách hàng =====
  // Trả về mảng field định danh đang lệch so với KH được gắn, null nếu không lệch
  dinhDanhDaDoi = () => {
    let { snapshotKH, CustomerID } = this.state;
    if (!snapshotKH || !(parseInt(CustomerID, 10) > 0)) return null;
    const chuanHoa = (v) =>
      (v === null || typeof v === "undefined" ? "" : String(v))
        .trim()
        .toLowerCase();
    // Ô Họ tên do react-hook-form giữ value, đọc qua gương CustomerNameNhap
    const giaTriHienTai = (f) =>
      f === "CustomerName" && this.state.CustomerNameNhap !== null
        ? this.state.CustomerNameNhap
        : this.state[f];
    let lech = Object.keys(NHAN_DINH_DANH).filter(
      (f) => chuanHoa(giaTriHienTai(f)) !== chuanHoa(snapshotKH[f]),
    );
    return lech.length > 0 ? lech : null;
  };

  // Chạy lại validate ô ẩn customer.CustomerID để xoá/hiện lỗi ngay
  validateLaiCustomerID = () => {
    let { currentForm } = this.props;
    if (currentForm && typeof currentForm.trigger === "function") {
      currentForm.trigger("customer.CustomerID");
    }
  };

  // "Đây là người khác" - bỏ gắn CustomerID, giữ nguyên dữ liệu đang nhập
  tachKhachMoi = () => () => {
    let { setEnableEditCustomer } = this.props;
    this.setState(
      {
        CustomerID: 0,
        CustomerId: 0,
        snapshotKH: null,
        xacNhanGhiDe: false,
        showClear: false,
        showButtonClear: false,
      },
      this.validateLaiCustomerID,
    );
    // mở khoá lại ô Họ tên (một số form cha không truyền prop này)
    if (typeof setEnableEditCustomer === "function") {
      setEnableEditCustomer({ IsEditCustomer: true });
    }
  };

  anXemKhachHang = () => {
    this.setState({ showXemKhachHang: false });
  };

  // "Đúng khách này" - cho phép ghi đè lên KH đang gắn
  xacNhanGhiDeKH = () => () => {
    this.setState({ xacNhanGhiDe: true }, this.validateLaiCustomerID);
  };

  render() {
    let {
      CustomerName,
      Img,
      CustomerID,
      Birthday,
      Phone,
      Address,
      CMT,
      DateCMT,
      AddressCMT,
      Code,
      HKTT,
      Profession,
      WorkAddress,
      Income,
      PersonContact,
      PhoneContact,
      Note,
      NameWife,
      PhoneWife,
      ProfessionWife,
      NameFather,
      PhoneFather,
      ProfessionFather,
      NameMother,
      PhoneMother,
      ProfessionMother,
      NoteFamily,
      NguonKhId,
      Email,
      DebtLevel,
      LoaiDoiTac,
      NguoiTheoDoi,
      showClear,
      showButtonClear,
      TenTaiKhoanIcloud,
      SoDienThoaiIcloud,
      TaiKhoanIcloudId,
      SoHDLienKet,
      sSearchNguonKhachHang,
      comboNguonKhachHangShow,
      snapshotKH,
      xacNhanGhiDe,
      quyenThongTinKhachVay,
      quyenThongTinKhac,
      quyenThanhPhanGiaDinh,
      quyenThongTinChoVay,
      quyenGhiChu,
      quyenThongTinKhacGiaDinh,
      NgheNghiepId,
      KhuVucId,
      HinhThucVayId,
      comboNgheNghiep,
      comboKhuVuc,
      comboHinhThucVay,
      isMoney88,
      showXemKhachHang,
    } = this.state;
    //Tab đầu tiên còn hiển thị sẽ được gán active
    const tabDauTien = quyenThongTinKhac
      ? "tab422"
      : quyenThanhPhanGiaDinh
        ? "tab423"
        : quyenThongTinChoVay
          ? "tab421"
          : "";
    let {
      autocompleteData,
      currentForm,
      userCombo,
      comboNguonKhachHang,
      errors,
      IsEditCustomer,
      IsCopy,
      CodeCuaHang,
      isCauHinhTaiKhoanIcloud,
    } = this.props;
    IsEditCustomer = !IsEditCustomer;
    const { register, control } = currentForm;
    // Các ô định danh đang lệch so với KH được gắn (null = không lệch)
    const lechDinhDanh = this.dinhDanhDaDoi();
    let image = Img;
    if (typeof Img === "undefined" || Img === "") {
      image = "/app-assets/images/icon-avatar-default.png";
    } else {
      if (image && image.indexOf("http") > -1) {
      } else {
        image = image;
      }
    }
    return (
      <div className="card-content">
        <div className="card-body">
          {/* <div className="row"> */}
          <div className="thong-tin-khach-vay">
            <div className="row col-md-12">
              <div className="col-md-3" style={{ marginRight: "-45px" }}>
                <div className="col-md-12 no-image1">
                  <div className="col-md-12">
                    <div>
                      <UploadCustomerImage
                        onChange={this.onChangeImg()}
                        image={Img}
                        Code={CodeCuaHang}
                      ></UploadCustomerImage>
                    </div>
                    <input
                      type="hidden"
                      name="customer.Img"
                      ref={register}
                      value={Img}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-md-9">
                <input
                  type="hidden"
                  name="CustomerID"
                  value={CustomerID}
                  ref={register}
                ></input>
                <input
                  type="hidden"
                  name="customer.TaiKhoanIcloudId"
                  value={TaiKhoanIcloudId}
                  ref={register}
                ></input>
                <input
                  type="hidden"
                  name="customer.SoHDLienKet"
                  value={SoHDLienKet}
                  ref={register}
                ></input>
                <input
                  type="hidden"
                  name="customer.CustomerID"
                  value={CustomerID}
                  ref={register({
                    validate: () =>
                      !this.dinhDanhDaDoi() ||
                      this.state.xacNhanGhiDe ||
                      "Thông tin đang nhập khác với khách hàng đang gắn. Vui lòng chọn 1 trong 2 phương án ở cảnh báo phía trên.",
                  })}
                ></input>
                <input
                  type="hidden"
                  name="customer.NguonKhId"
                  value={NguonKhId}
                  ref={register}
                ></input>
                {lechDinhDanh && (
                  <div
                    style={{
                      border: "1px solid #f0ad4e",
                      background: "#fcf8e3",
                      color: "#8a6d3b",
                      borderRadius: "4px",
                      padding: "8px 10px",
                      marginTop: "10px",
                      fontSize: "90%",
                      lineHeight: "1.6",
                    }}
                  >
                    <div>
                      <b>⚠ Cảnh báo ghi đè thông tin khách hàng</b>
                    </div>
                    <div>
                      Hợp đồng đang gắn với khách <b>#{CustomerID}</b> -{" "}
                      <b>{snapshotKH.CustomerName}</b> (SĐT:{" "}
                      {snapshotKH.Phone || "—"} - CCCD: {snapshotKH.CMT || "—"})
                    </div>
                    <div>
                      Bạn vừa sửa:{" "}
                      <b>
                        {lechDinhDanh.map((f) => NHAN_DINH_DANH[f]).join(", ")}
                      </b>{" "}
                      → Lưu sẽ <b>GHI ĐÈ</b> lên thông tin của khách hàng này.
                    </div>
                    <div style={{ marginTop: "6px" }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={this.tachKhachMoi()}
                      >
                        Đây là người khác - Tạo khách mới
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        style={{ marginLeft: "8px" }}
                        onClick={this.xacNhanGhiDeKH()}
                        disabled={xacNhanGhiDe}
                      >
                        {xacNhanGhiDe
                          ? "✓ Đã xác nhận cập nhật khách này"
                          : "Đúng khách này - Cập nhật thông tin"}
                      </button>
                    </div>
                    {errors.customer && errors.customer.CustomerID && (
                      <div
                        className="canh-bao-red"
                        style={{ marginTop: "4px", fontWeight: "bold" }}
                      >
                        {errors.customer.CustomerID.message}
                      </div>
                    )}
                  </div>
                )}
                {/* Khi hiển thị combo nguồn khách hàng của isMoney88 thì ô hidden
                    đi kèm combo đó đã đăng ký customer.NguonKhId, bỏ ô hidden ở
                    đây để tránh trùng tên field trong react-hook-form */}
                {!isMoney88 && (
                  <input
                    type="hidden"
                    name="customer.NguonKhId"
                    value={NguonKhId}
                    ref={register}
                  ></input>
                )}
                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-md-3" style={{ paddingRight: "0px" }}>
                    {showXemKhachHang && (
                      <ModalXemKhachHang
                        customerId={CustomerID}
                        onHide={this.anXemKhachHang}
                      />
                    )}
                    <label className="label-control color7-bold">
                      Họ Tên <span className="canh-bao-red">*</span>
                      {quyenThongTinKhachVay &&
                        parseInt(CustomerID, 10) > 0 && (
                          <button
                            type="button"
                            title="Xem thông tin cá nhân khách hàng"
                            onClick={() =>
                              this.setState({ showXemKhachHang: true })
                            }
                            style={{
                              background: "transparent",
                              border: "none",
                              padding: "0 0 0 6px",
                              lineHeight: 1,
                              color: "#056569",
                              fontSize: "18px",
                              cursor: "pointer",
                              verticalAlign: "middle",
                            }}
                          >
                            <i className="mdi mdi-eye"></i>
                          </button>
                        )}
                    </label>
                    <br />
                    <div class="input-group">
                      <Controller
                        control={control}
                        rules={{
                          required: "Hãy nhập tên khách hàng",
                          pattern: {
                            value: /(\w).+/i,
                            message: "Tên khách hàng phải nhiều hơn 2 từ",
                          },
                        }}
                        placeholder="Nhập họ tên"
                        name="customer.CustomerName"
                        defaultValue={CustomerName}
                        render={({ onChange, onBlur, value }) => (
                          <Autocomplete
                            wrapperProps={{}}
                            wrapperStyle={{
                              position: "relative",
                              width: "100%",
                            }}
                            inputProps={{
                              className:
                                "form-control input-sm card-autocomplete ",
                              readOnly: IsEditCustomer,
                            }}
                            menuStyle={{
                              borderRadius: "3px",
                              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                              padding: "2px 0",
                              fontSize: "90%",
                              position: "absolute",
                              overflow: "auto",
                              maxHeight: "150px", // TODO: don't cheat, let it flow to the bottom
                              top: "0 !important",
                              left: "0 !important",
                              zIndex: "1000",
                            }}
                            getItemValue={(item) => item.DinhDanh}
                            items={autocompleteData}
                            renderItem={(item, isHighlighted) => {
                              return (
                                <div
                                  className="auto-list"
                                  style={{
                                    background: isHighlighted
                                      ? "lightgray"
                                      : "white",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {item.DinhDanh}
                                </div>
                              );
                            }}
                            value={value}
                            onSelect={(val, item) => {
                              this.onSelectCustomer(val, item);
                              onChange(val);
                            }}
                            onChange={(evt) => {
                              onChange(evt);
                              this.onChangeCustomerText("CustomerName")(evt);
                            }}
                          />
                        )}
                      />
                      {showClear && CustomerID !== 0 && (
                        <>
                          <div
                            style={{
                              width: "99.5%",
                              zIndex: "999999",
                              height: "40px",
                              position: "absolute",
                              margin: "1px",
                            }}
                          >
                            {showButtonClear && (
                              <>
                                <button
                                  class="btn  hoten-chovay"
                                  onClick={this.clearCustomer()}
                                  type="button"
                                >
                                  x
                                </button>
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                    <span className="canh-bao-red">
                      {errors.customer &&
                        errors.customer.CustomerName &&
                        errors.customer.CustomerName.message}
                    </span>
                  </div>
                  <div className="col-md-3" style={{ paddingRight: "0px" }}>
                    <label className="label-control color7-bold">
                      Ngày sinh
                    </label>
                    <br />
                    <div>
                      <DateTimePicker
                        onChange={this.onChangeDate("Birthday")}
                        value={Birthday}
                        name="customer.Birthday"
                        customInputRef={register}
                        customInput={
                          <input
                            name="customer.Birthday"
                            ref={register}
                          ></input>
                        }
                      ></DateTimePicker>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ paddingRight: "0px" }}>
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      wrapperClass="form-group row"
                      labelText="Số CCCD"
                      inputWrapClass="col-md-8"
                      inputProps={{
                        name: "customer.CMT",
                        ref: register,
                        onChange: this.onChangeData("CMT"),
                        onBlur: this.onBlur("CMT"),
                        value: CMT,
                      }}
                    ></TextInputTwoRow>
                  </div>
                  <div className="col-md-3"></div>
                </div>
                {this.state.khachTrungCCCD && (
                  <div
                    style={{
                      border: "1px solid #f0ad4e",
                      background: "#fcf8e3",
                      color: "#8a6d3b",
                      borderRadius: "4px",
                      padding: "8px 10px",
                      marginTop: "10px",
                      fontSize: "90%",
                      lineHeight: "1.6",
                    }}
                  >
                    <div>
                      <b>
                        ⚠ Số CCCD {this.state.khachTrungCCCD.CMT} đã có trong hệ
                        thống
                      </b>
                    </div>
                    <div>
                      Khách hàng:{" "}
                      <b>
                        {(
                          (this.state.khachTrungCCCD.FirstName || "") +
                          " " +
                          (this.state.khachTrungCCCD.LastName || "")
                        ).trim()}
                      </b>
                      {this.state.khachTrungCCCD.Code &&
                        " (" + this.state.khachTrungCCCD.Code + ")"}
                    </div>
                    <div>
                      SĐT: {this.state.khachTrungCCCD.Phone || "—"} - Ngày sinh:{" "}
                      {this.state.khachTrungCCCD.Birthday
                        ? this.state.khachTrungCCCD.Birthday.toString().substring(
                            0,
                            10,
                          )
                        : "—"}{" "}
                      - Địa chỉ: {this.state.khachTrungCCCD.Address || "—"}
                    </div>
                    <div>
                      Bạn có muốn sử dụng thông tin khách hàng này không?
                    </div>
                    <div style={{ marginTop: "6px" }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={this.dungKhachTrungCCCD()}
                      >
                        Sử dụng thông tin khách hàng này
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        style={{ marginLeft: "8px" }}
                        onClick={this.boQuaKhachTrungCCCD()}
                      >
                        Không, nhập khách khác
                      </button> */}
                    </div>
                  </div>
                )}
                <div className="row" style={{ marginTop: "15px" }}>
                  <div className="col-md-3" style={{ paddingRight: "0px" }}>
                    <TextInputTwoRow
                      labelClass="col-md-4 label-control"
                      inputClass="form-control input-sm"
                      wrapperClass="form-group row"
                      labelText="Số điện thoại"
                      inputWrapClass="col-md-8"
                      inputProps={{
                        name: "customer.Phone",
                        ref: register,

                        onChange: this.onChangeData("Phone"),
                        onBlur: this.onBlur("Phone"),
                        value: Phone,
                      }}
                    ></TextInputTwoRow>
                  </div>
                  <div className="col-md-3" style={{ paddingRight: "0px" }}>
                    <TextInputOnRow
                      labelClass="label-control text-bold"
                      inputClass="form-control input-sm"
                      wrapperClass=""
                      labelText="Địa chỉ"
                      inputProps={{
                        name: "customer.Address",
                        ref: register,
                        onChange: this.onChangeData("Address"),
                        value: Address,
                        placeholder: "Nhập địa chỉ", // Thêm placeholder
                      }}
                    ></TextInputOnRow>
                  </div>
                  <div className="col-md-3" style={{ paddingRight: "0px" }}>
                    <label className="label-control  text-bold">
                      Ngày cấp CCCD
                    </label>
                    <DateTimePicker
                      onChange={this.onChangeDate("DateCMT")}
                      value={DateCMT}
                      name="customer.DateCMT"
                      customInputRef={register}
                      customInput={
                        <input name="customer.DateCMT" ref={register}></input>
                      }
                    ></DateTimePicker>
                  </div>
                  {quyenThongTinKhachVay && tabDauTien !== "" && (
                    <div className="col-md-3">
                      <label className="label-control  text-bold">&nbsp;</label>
                      <br />
                      <button
                        type="button"
                        className="btn-them-moi-thong-tin-ca-nhan"
                        data-toggle="collapse"
                        href="#collapse019998"
                        aria-expanded="false"
                        aria-controls="collapse019998"
                        style={{ margin: "0px" }}
                      >
                        <span>&nbsp; Thông tin cá nhân&nbsp;</span>
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className="row"
                  style={{ marginTop: "15px", paddingBottom: "20px" }}
                >
                  {isCauHinhTaiKhoanIcloud == true && (
                    <div className="col-md-3">
                      <label className="label-control text-bold">
                        Nguồn khách hàng <span className="canh-bao-red">*</span>
                      </label>
                      <div>
                        <Controller
                          control={control}
                          name="sSearchNguonKhachHang"
                          defaultValue={sSearchNguonKhachHang}
                          render={({ onChange, onBlur, value }) => (
                            <Autocomplete
                              wrapperProps={{}}
                              wrapperStyle={{
                                position: "relative",
                                width: "100%",
                              }}
                              inputProps={{
                                className:
                                  "form-control input-sm card-autocomplete",
                                onFocus: this.moDanhSachNguonKhachHang,
                              }}
                              menuStyle={{
                                borderRadius: "3px",
                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                background: "rgba(255, 255, 255, 0.9)",
                                padding: "2px 0",
                                fontSize: "90%",
                                position: "absolute",
                                overflow: "auto",
                                maxHeight: "150px", // TODO: don't cheat, let it flow to the bottom
                                top: "0 !important",
                                left: "0 !important",
                                zIndex: "1000",
                              }}
                              getItemValue={(item) => item.label}
                              renderInput={(props) => (
                                <input
                                  {...props}
                                  placeholder="Chọn nguồn khách hàng" // Thêm placeholder ở đây
                                />
                              )}
                              items={comboNguonKhachHangShow}
                              renderItem={(item, isHighlighted) => {
                                return (
                                  <div
                                    className="auto-list"
                                    style={{
                                      background: isHighlighted
                                        ? "lightgray"
                                        : "white",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {item.label}
                                  </div>
                                );
                              }}
                              value={this.state.sSearchNguonKhachHang}
                              onSelect={(value, item) => {
                                this.onSelectNguonKhachHang1(value, item);
                                onChange(value);
                              }}
                              onChange={(event, value) => {
                                onChange(event);
                                this.onChangeNguonKhachHang1(event, value);
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                  )}
                  {isCauHinhTaiKhoanIcloud == true && (
                    <div className="col-md-3">
                      <label className="label-control text-bold">
                        Tài khoản Icloud <span className="canh-bao-red">*</span>
                      </label>
                      <div>
                        <div class="input-group">
                          <Controller
                            control={control}
                            name="TenTaiKhoanIcloud"
                            defaultValue={TenTaiKhoanIcloud}
                            render={({ onChange, onBlur, value }) => (
                              <Autocomplete
                                wrapperProps={{}}
                                wrapperStyle={{
                                  position: "relative",
                                  width: "100%",
                                }}
                                inputProps={{
                                  className:
                                    "form-control input-sm card-autocomplete",
                                }}
                                menuStyle={{
                                  borderRadius: "3px",
                                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                  background: "rgba(255, 255, 255, 0.9)",
                                  padding: "2px 0",
                                  fontSize: "90%",
                                  position: "absolute",
                                  overflow: "auto",
                                  maxHeight: "150px", // TODO: don't cheat, let it flow to the bottom
                                  top: "0 !important",
                                  left: "0 !important",
                                  zIndex: "1000",
                                }}
                                getItemValue={(item) =>
                                  item.TenTaiKhoan + "-" + item.SoDienThoai
                                }
                                items={this.state.listTaiKhoanIcloud}
                                renderItem={(item, isHighlighted) => {
                                  return (
                                    <div
                                      className="auto-list"
                                      style={{
                                        background: isHighlighted
                                          ? "lightgray"
                                          : "white",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {item.TenTaiKhoan +
                                        "-" +
                                        item.SoDienThoai}
                                    </div>
                                  );
                                }}
                                value={this.state.TenTaiKhoanIcloud}
                                onSelect={(value, item) => {
                                  this.onSelectIcloud(value, item);
                                  onChange(value);
                                }}
                                onChange={(event, value) => {
                                  onChange(event);
                                  this.onChangeTextIcloud(event, value);
                                }}
                              />
                            )}
                          />
                        </div>
                        <span className="canh-bao-red">
                          {SoHDLienKet > -1 && (
                            <span>
                              Tài khoản đang được tạo với {SoHDLienKet} hợp đồng
                              liên kết
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                  )}

                  {isMoney88 && (
                    <>
                      <div className="col-md-3">
                        <label className="label-control text-bold">
                          Nghề nghiệp <span className="canh-bao-red">*</span>
                        </label>
                        <div>
                          <select
                            className="form-control input-sm select-v2"
                            value={NgheNghiepId}
                            onChange={this.onChangeSelectBatBuoc(
                              "NgheNghiepId",
                            )}
                          >
                            <option value="">-- Chọn nghề nghiệp --</option>
                            {this.comboConHieuLuc(
                              comboNgheNghiep,
                              NgheNghiepId,
                            ).map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                          <input
                            type="hidden"
                            name="customer.NgheNghiepId"
                            value={NgheNghiepId}
                            ref={register({ required: "Hãy chọn nghề nghiệp" })}
                          />
                        </div>
                        <span className="canh-bao-red">
                          {errors.customer &&
                            errors.customer.NgheNghiepId &&
                            errors.customer.NgheNghiepId.message}
                        </span>
                      </div>
                      <div className="col-md-3">
                        <label className="label-control text-bold">
                          Khu vực <span className="canh-bao-red">*</span>
                        </label>
                        <div>
                          <select
                            className="form-control input-sm select-v2"
                            value={KhuVucId}
                            onChange={this.onChangeSelectBatBuoc("KhuVucId")}
                          >
                            <option value="">-- Chọn khu vực --</option>
                            {this.comboConHieuLuc(comboKhuVuc, KhuVucId).map(
                              (item) => (
                                <option value={item.value} key={item.value}>
                                  {item.label}
                                </option>
                              ),
                            )}
                          </select>
                          <input
                            type="hidden"
                            name="customer.KhuVucId"
                            value={KhuVucId}
                            ref={register({ required: "Hãy chọn khu vực" })}
                          />
                        </div>
                        <span className="canh-bao-red">
                          {errors.customer &&
                            errors.customer.KhuVucId &&
                            errors.customer.KhuVucId.message}
                        </span>
                      </div>
                      <div className="col-md-3">
                        <label className="label-control text-bold">
                          Hình thức vay <span className="canh-bao-red">*</span>
                        </label>
                        <div>
                          <select
                            className="form-control input-sm select-v2"
                            value={HinhThucVayId}
                            onChange={this.onChangeSelectBatBuoc(
                              "HinhThucVayId",
                            )}
                          >
                            <option value="">-- Chọn hình thức vay --</option>
                            {this.comboConHieuLuc(
                              comboHinhThucVay,
                              HinhThucVayId,
                            ).map((item) => (
                              <option value={item.value} key={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                          <input
                            type="hidden"
                            name="customer.HinhThucVayId"
                            value={HinhThucVayId}
                            ref={register({
                              required: "Hãy chọn hình thức vay",
                            })}
                          />
                        </div>
                        <span className="canh-bao-red">
                          {errors.customer &&
                            errors.customer.HinhThucVayId &&
                            errors.customer.HinhThucVayId.message}
                        </span>
                      </div>
                      {isMoney88 && (
                        <div className="col-md-3">
                          <label className="label-control text-bold">
                            Nguồn khách hàng{" "}
                            <span className="canh-bao-red">*</span>
                          </label>
                          <div>
                            <select
                              className="form-control input-sm select-v2"
                              value={NguonKhId > 0 ? NguonKhId : ""}
                              onChange={this.onChangeSelectBatBuoc("NguonKhId")}
                            >
                              <option value="">
                                -- Chọn nguồn khách hàng --
                              </option>
                              {(comboNguonKhachHang || [])
                                .filter((item) => item.value > 0)
                                .map((item) => (
                                  <option value={item.value} key={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                            </select>
                            <input
                              type="hidden"
                              name="customer.NguonKhId"
                              value={NguonKhId > 0 ? NguonKhId : ""}
                              ref={register({
                                required: "Hãy chọn nguồn khách hàng",
                              })}
                            />
                          </div>
                          <span className="canh-bao-red">
                            {errors.customer &&
                              errors.customer.NguonKhId &&
                              errors.customer.NguonKhId.message}
                          </span>
                        </div>
                      )}
                    </>
                  )}

                  {this.state.IsNoXau == true ? (
                    <div className="col-md-12">
                      <div style={{ color: "#d50000" }}>
                        <i className="mdi mdi-information-outline"></i>
                        <span style={{ paddingLeft: "5px" }}>
                          Khách hàng đang có hợp đồng xấu trong hệ thống morman
                        </span>
                      </div>
                    </div>
                  ) : (
                    <> </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            id="collapse019998"
            role="tabpanel"
            aria-labelledby="headingCollapse01998"
            className="collapse"
          >
            <div className="card-content">
              <div className="card-body">
                <ul className="nav nav-tabs mt-1 bg-tab">
                  {quyenThongTinKhac && (
                    <li className="nav-item">
                      <a
                        className={
                          "nav-link" +
                          (tabDauTien === "tab422" ? " active" : "")
                        }
                        id="base-tab2"
                        data-toggle="tab"
                        aria-controls="tab2"
                        href="#tab422"
                        aria-expanded="false"
                      >
                        <h4>
                          <img src="/app-assets/images/icon-thong-tin-vay-v2.png" />
                          &nbsp;Thông tin khác
                        </h4>
                      </a>
                    </li>
                  )}

                  {quyenThanhPhanGiaDinh && (
                    <li className="nav-item">
                      <a
                        className={
                          "nav-link" +
                          (tabDauTien === "tab423" ? " active" : "")
                        }
                        id="base-tab2"
                        data-toggle="tab"
                        aria-controls="tab3"
                        href="#tab423"
                        aria-expanded="false"
                      >
                        <h4>
                          <img src="/app-assets/images/icon-thong-tin-gia-dinh-xanh.png" />
                          &nbsp;Thành phần gia đình
                        </h4>
                      </a>
                    </li>
                  )}

                  {quyenThongTinChoVay && (
                    <li className="nav-item">
                      <a
                        className={
                          "nav-link" +
                          (tabDauTien === "tab421" ? " active" : "")
                        }
                        id="base-tab1"
                        data-toggle="tab"
                        aria-controls="tab1"
                        href="#tab421"
                        aria-expanded="true"
                      >
                        <h4>
                          <img src="/app-assets/images/icon-thong-tin-vay-v2.png" />
                          &nbsp;Thông tin cho vay
                        </h4>
                      </a>
                    </li>
                  )}
                </ul>
                <div className="tab-content pt-1">
                  <div
                    className={
                      "tab-pane" + (tabDauTien === "tab422" ? " active" : "")
                    }
                    id="tab422"
                    aria-labelledby="base-tab2"
                  >
                    <div className="row">
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Mã Khách Hàng"
                          inputProps={{
                            name: "customer.Code",
                            ref: register,
                            onChange: this.onChangeData("Code"),
                            value: Code,
                            placeholder: "Nhập mã khách hàng", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nghề nghiệp"
                          inputProps={{
                            name: "customer.Profession",
                            ref: register,
                            onChange: this.onChangeData("Profession"),
                            value: Profession,
                            placeholder: "Nhập nghề nghiệp", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Người liên hệ"
                          inputProps={{
                            name: "customer.PersonContact",
                            ref: register,
                            onChange: this.onChangeData("PersonContact"),
                            value: PersonContact,
                            placeholder: "Nhập họ tên người liên hệ", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nơi cấp CCCD"
                          inputProps={{
                            name: "customer.AddressCMT",
                            ref: register,
                            onChange: this.onChangeData("AddressCMT"),
                            value: AddressCMT,
                            placeholder: "Nhập nơi cấp CCCD", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nơi làm việc"
                          inputProps={{
                            name: "customer.WorkAddress",
                            ref: register,
                            onChange: this.onChangeData("WorkAddress"),
                            value: WorkAddress,
                            placeholder: "Nhập nơi làm việc", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Số điện thoại người liên hệ"
                          inputProps={{
                            name: "customer.PhoneContact",
                            ref: register,
                            onChange: this.onChangeData("PhoneContact"),
                            value: PhoneContact,
                            placeholder: "Nhập số điện thoại người liên hệ", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Hộ khẩu thường trú"
                          inputProps={{
                            name: "customer.HKTT",
                            ref: register,
                            onChange: this.onChangeData("HKTT"),
                            value: HKTT,
                            placeholder: "Nhập địa chỉ thường trú", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Email"
                          inputProps={{
                            name: "customer.Email",
                            ref: register,
                            onChange: this.onChangeData("Email"),
                            value: Email,
                            placeholder: "Nhập email của khách hàng", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Thu nhập"
                          inputProps={{
                            name: "customer.Income",
                            ref: register,
                            onChange: this.onChangeData("Income"),
                            value: Income,
                            placeholder: "Nhập thu nhập", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>

                      {/* Quyền "Ghi chú" tắt thì ẩn ô này, vẫn giữ trong DOM để submit không ghi rỗng */}
                      <div
                        className="col-md-12"
                        style={quyenGhiChu ? undefined : { display: "none" }}
                      >
                        <div className="form-group">
                          <label className="label-control  text-bold">
                            Ghi chú
                          </label>
                          <textarea
                            style={{ minHeight: "80px" }}
                            rows="4"
                            className="textarea-customer input-sm"
                            name="customer.Note"
                            placeholder=""
                            ref={register}
                            value={Note}
                            onChange={this.onChangeData("Note")}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      "tab-pane" + (tabDauTien === "tab423" ? " active" : "")
                    }
                    id="tab423"
                    aria-labelledby="base-tab2"
                  >
                    <div className="row">
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Họ tên chồng/vợ"
                          inputProps={{
                            name: "customer.NameWife",
                            ref: register,
                            onChange: this.onChangeData("NameWife"),
                            value: NameWife,
                            placeholder: "Nhập họ tên", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Số điện thoại chồng/vợ"
                          inputProps={{
                            name: "customer.PhoneWife",
                            ref: register,
                            onChange: this.onChangeData("PhoneWife"),
                            value: PhoneWife,
                            placeholder: "Nhập họ tên", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nghề nghiệp chồng/vợ"
                          inputProps={{
                            name: "customer.ProfessionWife",
                            ref: register,
                            onChange: this.onChangeData("ProfessionWife"),
                            value: ProfessionWife,
                            placeholder: "Nhập nghề nghiệp", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Họ tên bố"
                          inputProps={{
                            name: "customer.NameFather",
                            ref: register,
                            onChange: this.onChangeData("NameFather"),
                            value: NameFather,
                            placeholder: "Nhập họ tên", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Số điện thoại bố"
                          inputProps={{
                            name: "customer.PhoneFather",
                            ref: register,
                            onChange: this.onChangeData("PhoneFather"),
                            value: PhoneFather,
                            placeholder: "Nhập số điện thoại", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nghề nghiệp bố"
                          inputProps={{
                            name: "customer.ProfessionFather",
                            ref: register,
                            onChange: this.onChangeData("ProfessionFather"),
                            value: ProfessionFather,
                            placeholder: "Nhập nghề nghiệp", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Họ tên mẹ"
                          inputProps={{
                            name: "customer.NameMother",
                            ref: register,
                            onChange: this.onChangeData("NameMother"),
                            value: NameMother,
                            placeholder: "Nhập họ tên", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Số điện thoại mẹ"
                          inputProps={{
                            name: "customer.PhoneMother",
                            ref: register,
                            onChange: this.onChangeData("PhoneMother"),
                            value: PhoneMother,
                            placeholder: "Nhập số điện thoại", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      <div className="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control  text-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Nghề nghiệp mẹ"
                          inputProps={{
                            name: "customer.ProfessionMother",
                            ref: register,
                            onChange: this.onChangeData("ProfessionMother"),
                            value: ProfessionMother,
                            placeholder: "Nhập nghề nghiệp", // Thêm placeholder
                          }}
                        ></TextInputOnRow>
                      </div>
                      {/* Quyền "Thông tin khác" tắt thì ẩn ô này, vẫn giữ trong DOM để submit không ghi rỗng */}
                      <div
                        className="col-md-12"
                        style={
                          quyenThongTinKhacGiaDinh
                            ? undefined
                            : { display: "none" }
                        }
                      >
                        <div className="form-group">
                          <label className="label-control  text-bold">
                            Thông tin khác
                          </label>
                          <textarea
                            style={{ minHeight: "80px" }}
                            rows="4"
                            className="textarea-customer input-sm"
                            name="customer.NoteFamily"
                            placeholder=""
                            ref={register}
                            value={NoteFamily}
                            onChange={this.onChangeData("NoteFamily")}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className={
                      "tab-pane" + (tabDauTien === "tab421" ? " active" : "")
                    }
                    id="tab421"
                    aria-labelledby="base-tab1"
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="text-bold">Tình trạng</label>
                              <select
                                className="selectBox form-control input-sm select-v2"
                                name="customer.DebtLevel"
                                ref={register}
                                defaultValue={"0"}
                                value={DebtLevel}
                                onChange={this.onChangeData("DebtLevel")}
                              >
                                {/* <option value="0">Bình thường</option>
                                <option value="50">Nợ xấu</option>
                                <option value="20">Nợ rủi ro</option> */}
                                {this.state.listTinhTrangNo.length > 0 &&
                                  this.state.listTinhTrangNo.map(
                                    (item, idx) => (
                                      <option
                                        key={"comboLoaiTaiSan" + idx}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </option>
                                    ),
                                  )}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="text-bold">Loại đối tác</label>
                              <select
                                className="form-control input-sm select-v2"
                                name="customer.LoaiDoiTac"
                                ref={register}
                                defaultValue={"1"}
                                value={LoaiDoiTac}
                                onChange={this.onChangeData("LoaiDoiTac")}
                              >
                                <option value="0">Chủ nợ</option>
                                <option value="1">Khách hàng</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="text-bold">
                                Người theo dõi
                              </label>
                              <select
                                className="form-control input-sm select-v2"
                                ref={register}
                                name="customer.NguoiTheoDoi"
                                value={NguoiTheoDoi}
                                onChange={this.onChangeData("NguoiTheoDoi")}
                              >
                                {userCombo.map((item) => (
                                  <option value={item.value} key={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <label className="text-bold">
                                Nguồn khách hàng
                              </label>
                              <select
                                className="form-control input-sm select-v2"
                                ref={register}
                                name="customer.NguonKH_ID"
                                value={NguonKhId}
                                onChange={this.onChangeData("NguonKhId")}
                              >
                                {comboNguonKhachHang.map((item) => (
                                  <option value={item.value} key={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
CustomerForm.Props = {};
export default CustomerForm;
